import type { CSSProperties } from 'react';
import { useLocation } from 'react-router';
import { useTileHeroViewTransitionStyle } from '@rocco/ui/tile-shared/hooks/use-tile-hero-view-transition';

/**
 * Media-box style for a product tile on a listing page.
 *
 * The claim matches either end of the transition, so the tile is named both
 * on the way out (its own click) and on the way back (the listing
 * re-rendering under a Back from that product) — the morph is symmetric
 * without extra bookkeeping. Tiles for every other product stay unnamed.
 *
 * A listing that renders the same product link twice would claim the name
 * twice; the browser then skips the transition and navigates instantly,
 * which is the pre-existing behaviour rather than a broken frame.
 */
export const useProductTileHeroStyle = (
    to: string | undefined,
): CSSProperties | undefined => useTileHeroViewTransitionStyle(to);

/**
 * Hero style for the product detail gallery's first slide — the tile's
 * counterpart. Matching on this page's own path means the slide is named for
 * transitions arriving here and for transitions leaving here, and stays
 * unnamed for navigations that have nothing to do with this product.
 */
export const useProductDetailHeroStyle = (): CSSProperties | undefined => {
    const { pathname } = useLocation();
    return useTileHeroViewTransitionStyle(pathname);
};
